import { computed } from "vue";
import { useUidAttribute } from "composables/useUidAttribute";
import { useSharedState } from "composables/useSharedState";
import { useTable } from "./useTable";
import { tableBodyVariants } from "./Table.styles";

export const useTableBody = () => {
  useUidAttribute();
  useSharedState({});

  const { scrollMode, bodyMaxHeightStyle } = useTable();
  const classes = computed(() => tableBodyVariants({ scroll: scrollMode.value }));

  return { classes, bodyMaxHeightStyle };
};
